import { render, staticRenderFns } from "./OrganizationPrivatePhone.vue?vue&type=template&id=2421ec9e"
import script from "./OrganizationPrivatePhone.vue?vue&type=script&lang=js"
export * from "./OrganizationPrivatePhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports